<template>
  <section>
    <Header></Header>
    <div class="body">
      <SectionPriceWelcome />
      <SectionPriceSelect
        label="화면당 단가"
        :list="list1"
        desc="화면 수에 비례하여 견적이 측정됩니다. 먼저 예상되시는 화면 수를 입력해주세요"
        @select="onSelect"
      />
      <SectionPriceSelect
        label="추가 기능"
        :list="list2"
        @select="onSelect"
        desc="이미 먼데이리스가 개발한기능을 고객사의 요구에 맞춰 커스터마이징하여 제공합니다. 목록에 없는 기능은 견적에 추가 될 수도 있습니다"
      />
      <SectionPriceSelect
        label="기타 할증"
        :list="list3"
        @select="onSelect"
        desc="고객사의 환경에 따른 할증이 있을 수 있습니다"
      />
    </div>
    <Footer></Footer>
    <div class="fixed">
      <div class="content">
        <div class="label">화면수(입력)</div>
        <input
          type="number"
          class="screen_count"
          v-model="screen_count"
          @input="onChange($event)"
          placeholder="화면수를 먼저 입력해주세요"
        />
        <div class="label2 pc">최종 예상 견적</div>
        <div class="amount_total">총</div>
        <div class="amount">{{ formattedPrice }}</div>
        <div class="button pc" @click="pdf">PDF로 다운로드</div>
      </div>
    </div>
  </section>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import loginService from "../services/loginService";
import client from "../client/client";

import SectionPriceWelcome from "../components/SectionPriceWelcome.vue";
import SectionPriceSelect from "../components/SectionPriceSelect.vue";

export default {
  name: "Main",
  components: {
    Header,
    Footer,
    SectionPriceWelcome,
    SectionPriceSelect,
  },
  data: function () {
    return {
      screen_count: 0,
      list1: [],
      list2: [],
      list3: [],
      amount: 0,
    };
  },
  computed: {
    formattedPrice() {
      return this.amount.toLocaleString() + "원";
    },
  },
  mounted() {
    this.list1 = [
      {
        text1: "앱 개발",
        text2: "앱(안드로이드 + iOS) 1화면당 기본가격",
        price: 300000,
      },
      {
        text1: "디자인 필요",
        text2: "시안 개수에 따라 추가가격 발생",
        price: 100000,
      },
      {
        text1: "API 개발",
        text2: "Node JS로 Front API를 개발합니다",
        price: 300000,
      },
      {
        text1: "관리자 백앤드 필요",
        text2: "앱 기능을 관리하기 위한 관리자 웹",
        price: 200000,
      },
      {
        text1: "UI UX 기획",
        text2: "앱의 구체적인 화면 설계를 도와드립니다",
        price: 300000,
      },
    ];

    this.list2 = [
      {
        text1: "채팅",
        text2: "푸시, 채팅, 채팅방 등의 기능이 포함됩니다",
        price: 3000000,
      },
      {
        text1: "카메라/비디오 업로드",
        text2: "사진 또는 영상을 업로드합니다",
        price: 1000000,
      },
      {
        text1: "QR/바코드 인식",
        text2: "카메라 QR코드 인식 및 바코드 생성 기능",
        price: 1000000,
      },
      {
        text1: "실시간 음성 채팅",
        text2: "실시간 음성 채팅과 그외 관련 기능을 제공합니다",
        price: 5000000,
      },
      {
        text1: "실시간 화상 채팅",
        text2: "실시간 화상 채팅과 그외 관련 기능을 제공합니다",
        price: 5000000,
      },
      {
        text1: "라이브 스트리밍",
        text2: "라이브 스트리밍과 그외 관련 기능을 제공합니다",
        price: 5000000,
      },
      {
        text1: "다국어",
        text2: "앱이 다중 언어로 개발됩니다",
        price: 2000000,
      },
      {
        text1: "결제",
        text2: "아임포트를 이용한 결제& 배송 기능을 제공합니다",
        price: 3000000,
      },
      {
        text1: "정산",
        text2: "오픈 마켓의 셀러 정산 기능을 제공합니다",
        price: 3000000,
      },
      {
        text1: "IOT 연동",
        text2: "IOT 기기와 연동 기능을 제공합니다",
        price: 3000000,
      },
      {
        text1: "블루투스 연동",
        text2: "블루투스와 연동합니다",
        price: 3000000,
      },
      {
        text1: "크롤링 및 데이터 정리",
        text2: "앱을 위한 데이터를 크롤링 하기 위해 개발 및 설계를 합니다",
        price: 2000000,
      },
      {
        text1: "백앤드 배치",
        text2: "요구 사항에 따라 백앤드 배치가 필요할 수 있습니다",
        price: 1000000,
      },
      {
        text1: "음성 레코드",
        text2: "음성을 업로드합니다",
        price: 1000000,
      },
      {
        text1: "뮤직 플레이어",
        text2: "일반적인 플레이어 기능입니다",
        price: 3000000,
      },
      {
        text1: "지도 기능",
        text2: "지도를 이용한 기능이 탑재됩니다",
        price: 1500000,
      },
    ];

    this.list3 = [
      {
        text1: "MySQL DB 할증",
        text2: "Mongodb가 아닌 다른 DB 사용시 할증",
        price: 2500000,
      },
      {
        text1: "자체서버 할증",
        text2: "AWS 가 아닌 OnPromise 서버 사용시 할증",
        price: 1500000,
      },
      {
        text1: "완료 문서 할증",
        text2: "각종 완료 문서 작성 시 할증",
        price: 150000,
      },
      {
        text1: "오프라인 미팅 혹은 개발",
        text2: "오프라인 미팅 혹은 현장에서의 개발이 있을 시 할증",
        price: 150000,
      },
    ];

    let id = 0;
    this.list1.forEach((item) => {
      item.id = id++;
    });
    this.list2.forEach((item) => {
      item.id = id++;
    });
    this.list3.forEach((item) => {
      item.id = id++;
    });
  },
  methods: {
    async onSelect(m) {
      this.price();
    },
    async pdf() {
      alert("PDF 다운로드는 준비 중입니다");
    },
    onChange(event) {
      this.price();
    },
    price() {
        let amount = 0;
        this.list1.forEach((item) => {
            if (item.selected) amount += item.price;
        });
        amount *= this.screen_count;

        this.list2.forEach((item) => {
            if (item.selected) amount += item.price;
        });
        this.list3.forEach((item) => {
            if (item.selected) amount += item.price;
        });
        
        this.amount = amount;
    },
  },
};
</script>

<style scoped>
.fixed {
  position: fixed;
  width: 100vw;
  height: 120px;
  background: #ffffff;
  bottom: 0px;
  left: 0px;
  z-index: 10;
  box-shadow: 20px 2px 8px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
}

.content {
  width: 100vw;
  max-width: 1440px;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
}

.label {
  font-size: 20px;
}
.screen_count {
  width: 100px;
  height: 50px;
  margin-left: 24px;
  font-size: 18px;
  border-radius: 8px;
  border: #aaa 1px solid;
  padding-left: 10px;
}

.label2 {
  margin-left: 100px;
  font-size: 20px;
  margin-left: 200px;
}

.amount_total {
  margin-left: 20px;
  color: #215fe6;
  font-size: 22px;
  font-weight: 700;
}
.amount {
  margin-left: 10px;
  font-size: 32px;
  font-weight: 700;
  color: #215fe6;
}

.button {
  margin-left: 100px;
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  background: #215fe6;
  width: 254px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
}

@media screen and (max-width: 1440px) {
  .fixed {
    position: fixed;
    width: 100vw;
    height: 80px;
  }
  .label {
    font-size: 16px;
  }
  .screen_count {
    width: 50px;
    height: 40px;
    margin-left: 10px;
    font-size: 18px;
    border-radius: 8px;
    border: #aaa 1px solid;
    padding-left: 10px;
  }

  .label2 {
    margin-left: 10px;
    font-size: 17px;
    margin-left: 200px;
  }

  .amount_total {
    margin-left: 30px;
    color: #215fe6;
    font-size: 18px;
    font-weight: 700;
  }
  .amount {
    margin-left: 10px;
    font-size: 20px;
    font-weight: 700;
    color: #215fe6;
  }
  .button {
    display: none;
  }
}
</style>
